import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  Row,
  Col,
  Tabs,
  Spin,
  Icon,
  Switch,
  Modal,
  Button,
  Pagination,
  DatePicker,
  Divider
} from 'antd';
import {
  fetchMetaData,
  fetchAlert,
  statusChange,
  ssrHandler
} from '../../actions/sessionActions';
const { RangePicker } = DatePicker;

const TabPane = Tabs.TabPane;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const columns = [
  {
    title: 'Name'
  },
  {
    title: 'Count'
  },
  {
    title: 'Start Time'
  },
  {
    title: 'Updated Time'
  },
  {
    title: 'Acknowledge'
  },
  {
    title: ''
  }
];

export class Alerts extends Component {
  static async fetchData({ dispatch }, match, route) {
    //   // Normally you'd pass action creators to "connect" from react-redux,
    //   // but since this is a static method you don't have access to "this.props".
    //
    //   // Dispatching actions from "static fetchData()" will look like this (make sure to return a Promise):
    await dispatch(ssrHandler(route.path));
    await dispatch(fetchMetaData()).then(alertTypes => {
      if (alertTypes.length > 0) {
        return dispatch(fetchAlert(alertTypes[0].code, 1));
      }
    });
  }

  constructor() {
    super();
    this.tabChange = this.tabChange.bind(this);
    this.state = {
      visible: false,
      startDate: null,
      endDate: null
    };
  }

  componentWillMount() {
    const { config, match } = this.props;
    this.setState({ startDate: null, endDate: null });
    if (match.path !== config.route && config.route !== '' && config.ssr) {
      this.props.fetchMetaData().then(alertTypes => {
        if (alertTypes.length > 0) {
          return this.props.fetchAlert(alertTypes[0].code, 1);
        }
      });
    }
  }

  tabChange(key) {
    const type = this.props.metadata.alertTypes[key].code;
    this.setState({ startDate: null, endDate: null });
    this.props.fetchAlert(type, 1);
  }

  showModal = (e, message) => {
    this.setState({
      visible: true,
      message: typeof message === 'string' ? message : JSON.stringify(message)
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false
    });
  };

  toggleEvent(e, idx) {
    this.props.statusChange(idx);
  }

  onChange = page => {
    const { startDate, endDate } = this.state;
    const { type } = this.props.alert;
    this.props.fetchAlert(type, page, startDate, endDate);
  };

  onRangeChange = (date, dateString) => {
    this.setState({ startDate: dateString[0], endDate: dateString[1] });
    const { type } = this.props.alert;
    this.props.fetchAlert(type, 1, dateString[0], dateString[1]);
  };

  render() {
    const { metadata, alert } = this.props;
    return (
      <div>
        <Row>
          <Col span={24}>
            <Tabs onChange={this.tabChange}>
              {metadata.alertTypes.map((item, i) => (
                <TabPane tab={item.name} key={i}>
                  <Row
                    className={`margin-bottom-10 ${
                      alert.type === 4 ? 'hide' : ''
                    }`}
                  >
                    <Col span={24}>
                      <span>Filter: </span>
                      <RangePicker onChange={this.onRangeChange} />
                    </Col>
                  </Row>
                  <Divider className={`${alert.type === 4 ? 'hide' : ''}`} />
                  {alert.isFetching ? (
                    <Spin indicator={antIcon} />
                  ) : (
                    <Fragment>
                      {alert.list.length <= 0 ? (
                        <div>&nbsp; No Data</div>
                      ) : (
                        <table
                          className={`ant-table cm-table ant-table-small width-100pt`}
                        >
                          <thead className="ant-table-thead">
                            <tr>
                              {columns.map((item, i) => (
                                <th className="padding-8" key={i}>
                                  {item.title}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody className="ant-table-tbody">
                            {alert.list.map((item, i) => (
                              <tr key={i}>
                                <td className="padding-8">{item.alert_name}</td>
                                <td className="padding-8">
                                  {item.alert_count}
                                </td>
                                <td className="padding-8">
                                  {moment(
                                    new Date(item.alert_start_time)
                                  ).format('Do MMM YY hh:mm a')}
                                </td>
                                <td className="padding-8">
                                  {moment(new Date(item.updated_at)).format(
                                    'Do MMM YY hh:mm a'
                                  )}
                                </td>
                                <td className="padding-8">
                                  <Switch
                                    defaultChecked
                                    checkedChildren="Active"
                                    unCheckedChildren="Inactive"
                                    onChange={e => this.toggleEvent(e, i)}
                                  />
                                </td>
                                <td>
                                  <Button
                                    type="primary"
                                    size="small"
                                    onClick={e =>
                                      this.showModal(
                                        e,
                                        item.extra_params.message
                                      )
                                    }
                                    disabled={
                                      item.extra_params.message ? false : true
                                    }
                                  >
                                    Message
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                      <br />
                      {alert.totalPages > 1 ? (
                        <Pagination
                          current={alert.pageNo}
                          pageSize={30}
                          onChange={this.onChange}
                          total={alert.totalPages * 30}
                        />
                      ) : null}
                    </Fragment>
                  )}
                </TabPane>
              ))}
            </Tabs>
          </Col>
        </Row>
        <Modal
          title="Message"
          visible={this.state.visible}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
        >
          <p>{this.state.message}</p>
        </Modal>
      </div>
    );
  }
}

Alerts.propTypes = {
  config: PropTypes.object,
  match: PropTypes.object,
  alert: PropTypes.object,
  metadata: PropTypes.object,
  fetchMetaData: PropTypes.func,
  fetchAlert: PropTypes.func,
  statusChange: PropTypes.func
};

Alerts.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  alert: state.session.alert
});

const mapDispatchToProps = dispatch => ({
  fetchMetaData: () => dispatch(fetchMetaData()),
  fetchAlert: (alertType, pageNo, startDate, endDate) =>
    dispatch(fetchAlert(alertType, pageNo, startDate, endDate)),
  statusChange: id => dispatch(statusChange(id))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Alerts));
